export function isZoomLink(link?: string): boolean {
  if (!link) return false;

  return link.includes("zoom.us");
}
